import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-belt-drive-drive-assembly',
    templateUrl: './belt-drive-drive-assembly.component.html',
    styleUrls: ['./belt-drive-drive-assembly.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class BeltDriveDriveAssemblyComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly imagePrefix = input<string>(undefined!);
  readonly valueChanged = output<void>();
  motorTypeSelection!: GuruEntity;
  motorSizeSelection!: GuruEntity;
  numberOfTurnsSelection!: GuruEntity;
  driveCodeLetterSelection!: GuruEntity;
  driveCodeNumberSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.DRIVE_ASSEMBLY;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.motorTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USMotorType');
    this.motorSizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USMotorSize');
    this.numberOfTurnsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USNumberTurns');
    this.driveCodeLetterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDriveCodeLetter');
    this.driveCodeNumberSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDriveCodeNum');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
